var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FFDB43"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41797 31.325C8.50271 31.167 8.55689 31.0588 8.61732 30.9546C9.55621 29.3492 10.4907 27.7412 11.4421 26.1431C11.5727 25.9238 11.5623 25.7921 11.4078 25.5905C6.40659 19.0625 10.3309 9.64759 18.5198 8.52124C24.3191 7.72356 29.7927 11.7232 30.6709 17.4394C31.1396 20.4847 30.4112 23.2505 28.504 25.694C28.3333 25.9126 28.3051 26.0568 28.4519 26.3045C29.3623 27.8398 30.2516 29.3872 31.1475 30.931C31.2093 31.0377 31.2669 31.1466 31.3653 31.325C30.8979 31.325 30.4809 31.3276 30.0639 31.325C29.6239 31.3218 29.1032 31.4555 28.7686 31.2668C28.4341 31.078 28.281 30.5691 28.0606 30.1934C25.6918 26.1568 21.1776 18.4549 18.8076 14.4183C18.6721 14.189 18.6508 14.0167 18.7879 13.7762C19.1711 13.1053 19.5221 12.4163 19.9301 11.6517L26.9656 23.7296C28.8325 21.3026 29.256 16.7343 26.1856 13.4578C23.1038 10.1687 18.0245 9.85699 14.5623 12.7468C11.0429 15.6841 10.7945 20.506 12.9184 23.6117L19.9301 11.6517C20.1459 12.0205 20.3394 12.342 20.5242 12.6686C20.7815 13.1209 21.0917 13.5657 21.0945 14.023C21.097 14.465 20.7794 14.9234 20.5205 15.3649C17.4606 20.5742 14.402 25.7842 11.3446 30.9948C11.2004 31.2409 11.051 31.3429 10.7563 31.3337C9.99475 31.3094 9.23206 31.325 8.41797 31.325Z",
    fill: "#1D2624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 29.3335L14.9452 27.3525C18.2632 29.514 21.5927 29.5378 24.9655 27.4179L26.1146 29.3738C22.9819 31.835 17.456 32.1134 13.7812 29.3335Z",
    fill: "#1D2624"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9474,
    height: 22.9474,
    fill: "white",
    transform: "translate(8.41992 8.41992)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/smallLogo.dd39b7562b405420ea4a711b303a58c3.svg";
export { ForwardRef as ReactComponent };